// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Retomada_ContatoResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Resposta de /retomada/registrar_contato (chamado 2026-0052): o contato que passa a
 * valer para a linha. `ja_existia` = ja havia contato de hoje para o mesmo cliente e
 * categoria, e nada novo foi gravado (dois cliques nao contam dois contatos na meta).
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Retomada_ContatoResponseDados {
contato_id: number
ja_existia: boolean
contato_em?: string
contato_canal?: string
contato_por?: string
}

export type Retomada_ContatoResponse = ApiResponse<Retomada_ContatoResponseDados>;

registerResponseContract('Retomada_ContatoResponse', {
  contato_id:    { type: 'number',  required: true },
  ja_existia:    { type: 'boolean', required: true },
  contato_em:    { type: 'string',  required: false },
  contato_canal: { type: 'string',  required: false },
  contato_por:   { type: 'string',  required: false },
})
